import { Component, Input } from '@angular/core';

import { SubstitutionBoardEnumerations } from '../../../interfaces/interfaces.module';
import { SubBoardListItemModel } from '../../models/sub-board-list-item-model';

@Component({
    selector: 'app-substitution-request-list-item-body',
    templateUrl: './substitution-request-list-item-body.component.html',
    styleUrls: ['./substitution-request-list-item-body.component.scss'],
    standalone: false
})
export class SubstitutionRequestListItemBodyComponent {
    @Input() public model: SubBoardListItemModel;

    @Input() public showStatus = true;

    constructor() {}

    get isOpen(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.open.code;
    }

    get isClosed(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.closed.code;
    }

    get isCanceled(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.cancelled.code;
    }

    get isOverdue(): boolean {
        return this.model.status.code === SubstitutionBoardEnumerations.SubstitutionRequestStatus.overdue.code;
    }

    get shouldShowSubstitute() {
        return this.model.substitutePhotoUrl || this.model.substituteFirstName;
    }
}
